import {Flex, Image, Text} from '@chakra-ui/react'
import AvatarResult from '@assets/images/exam/avatar-result.png'
import {useSelector} from 'react-redux'
import {styleByTextTag} from '@utils'

const Header = () => {
  const {dataExamResult} = useSelector((state: any) => state.examResult)

  return (
    <Flex borderRadius={'20px'} bg={'white'} position={'relative'}>
      <Flex p={{base: '16px', md: '80px'}} flexDirection={'column'}>
        <Text fontSize={{base: '16px', md: '20px'}} fontWeight={600}>
          Kết quả bài nói của bạn
        </Text>
        <Text
          fontSize={{base: '20px', md: '40px'}}
          fontWeight={700}
          mt={'20px'}>
          {`Bài nói đạt điểm ${dataExamResult?.statistics?.overall.toFixed(1)}`}
        </Text>
        <Text
          sx={{
            '.orange-text': {
              color: '#EC652C',
            },
          }}
          fontSize={{base: '20px', md: '40px'}}
          fontWeight={700}
          maxW={'700px'}>
          {styleByTextTag(dataExamResult?.overall_feedback)}
        </Text>
      </Flex>
      <Image
        display={{base: 'none', lg: 'block'}}
        src={AvatarResult}
        position={'absolute'}
        bottom={0}
        right={'80px'}
      />
    </Flex>
  )
}

export default Header
